import React, { useState } from 'react';
import { Lock, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ClientLoginPage = () => {
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // NO REAL AUTHENTICATION IMPLEMENTED
    // This is a frontend placeholder only. Backend authentication to be implemented by dev team.
    console.log('Login attempt:', loginForm.email);
    alert('This is a placeholder login page. Authentication to be implemented by the development team.');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 flex flex-col">
      <Header />
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img 
            src="/images/logos/samvedanam_logo_2x.png" 
            alt="Samvedanam Logo" 
            className="h-12 w-auto mx-auto mb-6"
          />
          <h1 className="text-3xl font-bold text-white mb-2">Client Portal</h1>
          <p className="text-slate-400">Access your deal dashboard and documents</p>
        </div>

        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-2xl text-white text-center">Login</CardTitle>
            <CardDescription className="text-slate-400 text-center">
              For existing clients only
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-slate-300 text-sm mb-2 block">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                  <Input
                    type="email"
                    placeholder="your.email@company.com"
                    value={loginForm.email}
                    onChange={(e) => setLoginForm({...loginForm, email: e.target.value})}
                    required
                    className="bg-slate-700/50 border-slate-600 text-white pl-10"
                  />
                </div>
              </div>

              <div>
                <label className="text-slate-300 text-sm mb-2 block">Password</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                  <Input
                    type="password"
                    placeholder="••••••••"
                    value={loginForm.password}
                    onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
                    required
                    className="bg-slate-700/50 border-slate-600 text-white pl-10"
                  />
                </div>
              </div>

              <Button type="submit" className="w-full bg-amber-600 hover:bg-amber-700 text-white">
                <Lock className="mr-2 h-4 w-4" />
                Login
              </Button>

              <div className="text-center">
                <button 
                  type="button" 
                  className="text-amber-500 hover:text-amber-400 text-sm"
                  onClick={() => alert('Please contact reachus@samvedanam.com to reset your password')}
                >
                  Forgot password?
                </button>
              </div>
            </form>

            <div className="mt-6 pt-6 border-t border-slate-700">
              <p className="text-slate-400 text-sm text-center leading-relaxed">
                To request access to the client portal, please email{' '}
                <a href="mailto:reachus@samvedanam.com" className="text-amber-500 hover:text-amber-400">
                  reachus@samvedanam.com
                </a>
              </p>
            </div>

            <div className="mt-6">
              <Card className="bg-amber-500/10 border-amber-500/20">
                <CardContent className="p-4">
                  <p className="text-amber-500 text-xs text-center">
                    ⚠️ This is a front-end placeholder only. Real authentication 
                    will be implemented by the development team.
                  </p>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-6">
          <Button 
            variant="ghost" 
            className="text-slate-400 hover:text-white"
            onClick={() => window.location.href = '/'}
          >
            ← Back to Home
          </Button>
        </div>
      </div>
    </div>
      <Footer />
    </div>
  );
};

export default ClientLoginPage;
